/**
 * @file 現在地取得
 */
'use strict';

import Common from "../../Utils/Common";

/**
 * @classname GetLocation
 * @classdesc 現在地取得
 */
export default class GetLocation {
	/**
	 * @constructor
	 * @param {object} controller - controller オブジェクト
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('GetLocation.constructor');
		this._$e = $e;
		this._controller = controller;
        this._markers = [];
        this._$markers = [];
        let timer = setInterval(() => {
            if($('#mapReady').val() === '1'){
                clearInterval(timer);
                this.setInitMap();
            }
        },500);
        controller.on('completeGetFacilities', () => this.completeGetFacilities());
        $('.btn--location-search').on('click', e => this.selectCategory(e));
        $('.form-check-input').on('click', e => this.selectCategory(e));
    };


    /**
     * 地図設定
     *
     * @memberof GetLocation
     * @return {undefined}
     */
    setInitMap() {
        console.log('GetLocation.setInitMap');
        let metroLat = 35.689634;
        let metroLng = 139.692101;
        this._controller.setLatLng(metroLat, metroLng);
        this._pos = new google.maps.LatLng({lat: metroLat, lng: metroLng});
        const  mapOption = {
            center: this._pos,
            zoom: 17,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false
        }
        this._map = new google.maps.Map(document.getElementById("map-location"), mapOption);
        this._map.addListener('bounds_changed', () => {
            setTimeout(()=> {
                this.boundsChanged()
            },1000);
        });
        this._controller.getFacilities(17);
        this.getGpsLocation();
    };


    /**
     * 地図設定
     *
     * @memberof GetLocation
     * @return {undefined}
     */
    getGpsLocation() {
        console.log('GetLocation.getGpsLocation');
        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };
        navigator.geolocation.getCurrentPosition(this.setLocation.bind(this), this.error.bind(this), options);
    };

	/**
	 * 地図設定
	 *
	 * @memberof GetLocation
	 * @return {undefined}
	 */
	setLocation(position) {
		console.log('GetLocation.setLocation');
		console.log(position);
		const pos = position.coords;
		this._controller.setLatLng(pos.latitude, pos.longitude);
		this._pos = new google.maps.LatLng({lat: position.coords.latitude, lng: position.coords.longitude});
		this._map.setCenter(this._pos);
        this._markers = [];
        this._$markers = [];
	};


	/**
	 * 施設情報取得完了
	 *
	 * @memberof GetLocation
	 * @return {undefined}
	 */
	completeGetFacilities(position) {
		console.log('GetLocation.completeGetFacilities');
		this._data = this._controller._data;
		this._list = this._data.list;
		const myMap = this._map;
		//console.log(this._list);
		let currentInfoWindow = null;
		for(let i = 0; i < this._list.length; i++){
			const marker = this._list[i];
			//console.log(marker);
			let categoryMarker;
			let shop = false;
			let flat = false;
			let hospital = false;
			let toilet = false;
			let bicycle = false;
			var flat_female = false;
			let facility;
			let contentString;
			let category;
			if(marker.facility.length > 1){
				contentString = `<div class="info-window">`;
				for(let j = 0; j < marker.facility.length; j++){
					facility = marker.facility[j];
					//console.log(facility);
					if(facility.sponsor){
						shop = true;
					}
					if(facility.flat){
						flat = true;
					}
					if(facility.hospital){
						hospital = true;
					}
					if(facility.toilet){
						toilet = true;
					}
					if(facility.bicycle){
						bicycle = true;
					}
					if (facility.flat_female) {
					  flat_female = true;
					}
					if(shop){
						category = 'shop';
					}else if(flat){
						category = 'flat';
					}else if(hospital){
						category = 'hospital';
					}else if(toilet){
						category = 'toilet';
					}else if(bicycle){
						category = 'bicycle';
					} else if (flat_female) {
						category = 'flat-female';
					}
					contentString += `
<a class="anchor" href="${facility.url}">${facility.name}<i class="icon icon--${category}"></i></a>
<p class="text">住所： ${facility.address}</p>`;
					if(facility.tel){
						contentString += `<p class="text">電話： ${facility.tel}</p>`;
					}
				}
				contentString += `</div>`
				//console.log(contentString);
			}else{
				facility = marker.facility[0];
				//console.log(facility);
				if(facility.sponsor){
					shop = true;
				}else if(facility.flat){
					flat = true;
				}else if(facility.firstaid){
					hospital = true;
				}else if(facility.toilet){
					toilet = true;
				}else if(facility.parking){
					bicycle = true;
				} else if (facility.flat_female) {
					flat_female = true;
				}
				//console.log(facility.name);
				//console.log(shop,flat,hospital,toilet,bicycle);
				if(shop){
					category = 'shop';
				}else if(flat){
					category = 'flat';
				}else if(hospital){
					category = 'hospital';
				}else if(toilet){
					category = 'toilet';
				}else if(bicycle){
					category = 'bicycle';
				} else if (flat_female) {
					category = 'flat-female';
				}
				contentString =
`<div class="info-window">
<a class="anchor" href="${facility.url}">${facility.name}<i class="icon icon--${category}"></i></a>
<p class="text">住所： ${facility.address}</p>`;
				if(facility.tel) {
					contentString += `<p class="text">電話： ${facility.tel}</p>`;
				}
			}
			if(shop){
				categoryMarker = '/img/icons/icon-shop.png?v=202407';
			}else if(flat){
				categoryMarker = '/img/icons/icon-flat.png?v=202407';
			}else if(hospital){
				categoryMarker = '/img/icons/icon-hospital.png?v=202407';
			}else if(toilet){
				categoryMarker = '/img/icons/icon-toilet.png?v=202407';
			}else if(bicycle){
				categoryMarker = '/img/icons/icon-bicycle.png?v=202407';
			} else if (flat_female) {
				categoryMarker = '/img/icons/icon-flat-female.png?v=202407';
			}
			const lat = parseFloat(marker.lat);
			const lng = parseFloat(marker.lng);
			const LatLng = new google.maps.LatLng({lat: lat, lng: lng});
			const markerLatLng = `${lat}/${lng}`;
			if(!this._markers.includes(markerLatLng)){
				this._markers.push(markerLatLng);
				const mapMarker = new google.maps.Marker({
					position: LatLng,
					map: this._map,
					icon: new google.maps.MarkerImage(
						categoryMarker, //マーカー画像URL
						new google.maps.Size(25, 39), //マーカー画像のサイズ
						new google.maps.Point(0, 0)
					),
				});
				this._$markers.push(mapMarker);
				const infowindow = new google.maps.InfoWindow({
					content: contentString,
				});
				mapMarker.addListener('click', () => {
					if (currentInfoWindow) {
						currentInfoWindow.close();
					}
					infowindow.open({
						anchor: mapMarker,
						myMap,
						shouldFocus: false,
					});
					currentInfoWindow = infowindow;
				});
			}
		}
		// console.log(this._markers);
	};


	/**
	 * ビューポート変更
	 *
	 * @memberof GetLocation
	 * @return {undefined}
	 */
	boundsChanged() {
		console.log('GetLocation.boundsChanged');
		const latlng = this._map.getCenter();
		const lat = latlng.lat();
		const lng = latlng.lng();
		//console.log(lat, lng);
		this._controller.setLatLng(lat, lng);
		const zoom = this._map.getZoom();
		this._controller.getFacilities(zoom);
	};


	/**
	 * カテゴリー選択
	 *
	 * @memberof GetLocation
	 * @return {undefined}
	 */
	selectCategory(e) {
		console.log('GetLocation.selectCategory');
		const $e = $(e.currentTarget);
		if($e.hasClass('active')) {
			$e.removeClass('active');
		}else{
			$e.addClass('active');
		}
		for(let i = 0; i < this._$markers.length; i++){
		    this._$markers[i].setMap(null);
        }
		this._markers = [];
		this._$markers = [];
		this.boundsChanged();
	};


	/**
	 * 現在地取得エラー
	 *
	 * @memberof GetLocation
	 * @return {undefined}
	 */
	error(error){
		console.log('GetLocation.error');
		if(error.code === 1){
		    alert("位置情報の取得に失敗しました。\n位置情報の取得が許可されていません。\n\n住所を都庁に設定します。");
		}else{
            alert("位置情報の取得に失敗しました。\n\n住所を都庁に設定します。");
		}
    };
}
